import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { UserCredentials } from '@arpada/arp-lib-common-qupro';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConformesFilter, InputAgreement } from './api.services';
import { AgreementDefaultOrder } from './classes/conformes-order';

@Injectable({
  providedIn: 'root'
})
export class ConformesService {
  private static CREDENTIAL_SEPARATOR = ':';
  private static CREDENTIAL_PREFIX = 'TOKEN-';
  private static SEARCH_CONFORMES = '/get-supplier-agreements';
  private static CREATE_CONFORME = '/upload-agreement';

  uploadAgreementEvent = new EventEmitter();

  constructor(private httpClient: HttpClient) { }

  public getSupplierConformes(filter: ConformesFilter): Observable<Object> {
    const httpOptions = this.createHttpOptions();
    const defaultOrder: AgreementDefaultOrder = new AgreementDefaultOrder();
    defaultOrder.direction = 'desc';
    defaultOrder.name = 'id';
    filter.order = [];
    filter.order.push(defaultOrder);
    const body = filter;
    return this.httpClient.post(environment.fastapiExposedQuproQueriesBaseURL + ConformesService.SEARCH_CONFORMES, body, httpOptions);
  }

  public createSupplierConforme(inputAgreement: InputAgreement): Observable<Object> {
    const httpOptions = this.createHttpOptions();
    const body = inputAgreement;
    return this.httpClient.post(environment.fastapiExposedQuproCommandsBaseURL + ConformesService.CREATE_CONFORME, body, httpOptions);
  }

  private createHttpOptions() {
    const userCredentialToken: string = this.getUserCredentialToken();
    const httpOptions = {
            headers: new HttpHeaders({
            'app-key': environment.proveedorApiToken,
            Authorization: 'Basic ' + btoa(userCredentialToken),
            }),
            params: new HttpParams().set('mode', 'proveedor')
    };
    return httpOptions;
  }

  private getUserCredentialToken(): string {
    const userCredentials: UserCredentials = UserCredentials.load();
    const userCredentialToken: string = userCredentials.getUsername() + ConformesService.CREDENTIAL_SEPARATOR + ConformesService.CREDENTIAL_PREFIX + userCredentials.getTokenPass();
    return userCredentialToken;
  }
}
